import React, { useState, useEffect } from "react";
import { Pie } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";

// Register ChartJS components
ChartJS.register(ArcElement, Tooltip, Legend);

const PieChart = ({ apiData }) => {
    const [chartData, setChartData] = useState({
        labels: [],
        datasets: [
            {
                label: "",
                data: [],
                backgroundColor: [],
                borderColor: [],
                borderWidth: 1,
            },
        ],
    });
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchData = async () => {
            try {
                // Transform API data to chart format
                const labels = apiData.map((item) => item.label);
                const values = apiData.map((item) =>
                    item.value === 0 ? 0.0001 : item.value
                );

                setChartData({
                    labels: labels,
                    datasets: [
                        {
                            label: "Data from API",
                            data: values,
                            backgroundColor: Array(values.length).fill(
                                "transparent"
                            ),
                            borderColor: [
                                "#F85006", // lavender blue
                                "#b9b9b9", // soft blue
                                "#FFA350", // pastel orange
                                "#FCA6A6", // light pink
                            ],
                            borderWidth: 20,
                            borderAlign: "inner",
                        },
                    ],
                });

                setLoading(false);
            } catch (err) {
                setError(err.message);
                setLoading(false);
            }
        };

        fetchData();
    }, [apiData]);

    const chartOptions = {
        responsive: true,
        maintainAspectRatio: false,
        cutout: "75%",
        animation: {
            duration: 0,
        },
        plugins: {
            legend: {
                display: false, // This hides the legend
            },
            tooltip: {
                callbacks: {
                    label: function (context) {
                        const label = context.label || "";
                        const value = context.raw || 0;
                        return `${label}: ${value}`;
                    },
                },
            },
        },
    };
    if (loading) return <div>Loading chart data...</div>;
    if (error) return <div>Error: {error}</div>;

    return (
        <div
            style={{
                width: "100%",
                height: "110px",
                margin: "0 auto",
            }}
        >
            <Pie data={chartData} options={chartOptions} />
        </div>
    );
};

export default PieChart;
